import axiosFactory from './axios';
import queryString from '../utils/queryString';

// used in sms and incoming

export default function service(endPoint, method, data, query) {
    let axios = axiosFactory();
    let options = {};
    // let Dpk ;
    // method.toLowerCase() === 'post' ? Dpk = data.dpk : Dpk = null ;
    let headers =   {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                        Dpk: data.dpk
                    }
    query = queryString(query);
    options.url = query ? `${endPoint}?${query}` : `${endPoint}`;
    if(method.toLowerCase() != 'get') options.data = data;
    return axios.request({
        method: `${method}`,
        ...options,
        headers: headers
    });
}